import { useLocation, useNavigate } from "react-router-dom"

import { SidebarGroup, SidebarGroupLabel, SidebarMenu, SidebarMenuButton, SidebarMenuItem } from "@ui/sidebar"
import { NavigationSectionModel } from "@/models/navigation"

interface NavigationSectionProps {
    section: NavigationSectionModel
}
export function NavigationSection({ section }: Readonly<NavigationSectionProps>) {
    const location = useLocation()
    const navigate = useNavigate()

    return (
        <SidebarGroup>
            <SidebarGroupLabel>{section.title}</SidebarGroupLabel>
            <SidebarMenu>
                {
                    section.items.map((item) => (
                        <SidebarMenuItem key={item.title} className={`${location.pathname === item.url ? "rounded-md bg-gray-200" : ""}`}>
                            <SidebarMenuButton asChild tooltip={item.tooltip} onClick={() => navigate(item.url)} className='hover:cursor-pointer'>
                                <div>
                                    <item.icon />
                                    <span>{item.title}</span>
                                </div>
                            </SidebarMenuButton>
                        </SidebarMenuItem>
                    ))
                }
            </SidebarMenu>
        </SidebarGroup>
    )
}
